// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___bfbaf8b88b5eacb06a5{/*!*/}.Unibrow-cls2___5f1cdb1afb671f157a1{padding-right:8px;padding-right:var(--spacing-xs-8, 8px);display:flex;flex-direction:column;justify-content:center;align-items:flex-start;grid-gap:4px;gap:4px;grid-gap:var(--spacing-xs-4, 4px);gap:var(--spacing-xs-4, 4px);flex:1 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___bfbaf8b88b5eacb06a5",
	"cls2": "Unibrow-cls2___5f1cdb1afb671f157a1 Unibrow-cls1___bfbaf8b88b5eacb06a5"
};
export default ___CSS_LOADER_EXPORT___;
